// Stores
import { ActionType } from "@ms/planner-actions/lib/local/ActionType";
/** A tuple of the supported ActionType values for PortfolioStore, for use in the registry */ export const PortfolioStoreActionTypes = [
    ActionType.FetchEntityCollectionAction,
    ActionType.FetchEntityCollectionSucceededAction,
    ActionType.FetchEntityCollectionFailedAction,
    ActionType.CreateEntityAction,
    ActionType.CreateEntitySucceededAction,
    ActionType.CreateEntityFailedAction,
    ActionType.DeleteEntityAction,
    ActionType.DeleteEntitySucceededAction,
    ActionType.DeleteEntityFailedAction,
    ActionType.UpdateEntityAction,
    ActionType.UpdateEntitySucceededAction,
    ActionType.UpdateEntityFailedAction,
    ActionType.EnqueuePostProvisioningPortfolioCreationAction
];
